<script setup lang="ts">
import { PublicReturnAddress } from '@gql/PublicReturnAddress'

const t2 = useT2({
  'Full name': 'Vardas ir pavardė',
  Address: 'Adresas',
  City: 'Miestas',
  State: 'Apskritis / Valstija',
  'Post code': 'Pašto kodas',
  'Telephone number': 'Telefono numeris',
  'Delivery instructions': 'Pristatymo instrukcijos',
  apartment: {
    en: 'Apartment, suite, unit, building, floor, etc.',
    lt: 'Butas, patalpa, korpusas, pastatas, aukštas ir kt.',
  },
})
const props = defineProps<{
  sellerId: string | None
  msg?: stringI18n
}>()

const { ui } = useApolloWrap2<gen.PublicReturnAddressQuery, gen.PublicReturnAddressQueryVariables>(PublicReturnAddress)({
  vars() {
    const { sellerId } = props
    return sellerId ? { sellerId } : undefined
  },
  ui: (i) => i?.publicReturnAddress,
})
</script>

<template>
  <div>
    <div v-if="msg" class="_italic _pb1">{{ msg }}</div>
    <UiCountry :country="ui?.country" right />
    <UiLine :label="t2('Full name')" :value="ui?.fullname.value" />
    <UiLine :label="t2('Address')" :value="ui?.street.value" />
    <UiLine :label="t2('apartment')" :value="ui?.apartment?.value" />
    <UiLine :label="t2('City')" :value="ui?.city.value" />
    <UiLine :label="t2('State')" :value="ui?.state?.value" />
    <UiLine :label="t2('Post code')" :value="ui?.postCode?.value" />
    <UiLine :label="t2('Telephone number')" :value="ui?.tel?.value" />
    <UiLine :label="t2('Delivery instructions')" :value="ui?.deliveryInstruction?.value" />
  </div>
</template>
